import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { CustomProvider } from 'rsuite';
import { useCookiesLogin } from './config/cookies';
import { RouterManager } from './routes/routerManager';
import ComponentLogin, { LoginForm } from './scenes/login';
import ComponentProfile from './scenes/profile';
import ResetPassword, { ResetPasswordForm } from './scenes/resetPassword';
import Template from './template';
import TermsWrapper from './scenes/termsScreen';
import HelpPage from './scenes/termsScreen/faq';
import ComponentLeadForm from './scenes/leadForm';
import { useEffect, useMemo } from 'react';
import { ToastContainer } from 'react-toastify';
import { AuthLayout } from './components/AuthLayout';
import { ForgotPasswordForm, RecoverPasswordForm } from './scenes/recoverPassword';
import { RegisterForm } from './scenes/register';
import OnboardingWrapper from './scenes/onboarding/OnboardingWrapper';

function App() {
  const { cookies } = useCookiesLogin();
  const access = cookies.AUTH_TOKEN?.role ?? '';
  // const [rsuiteTheme, setRsuiteTheme] = useState(() => {
  //   const savedMode = localStorage.getItem('themeMode');
  //   return savedMode === 'dark' ? 'dark' : 'light';
  // });

  useEffect(() => {
    // const handleThemeChange = (event) => {
    //   setRsuiteTheme(event.detail === 'dark' ? 'dark' : 'light');
    // };
    // window.addEventListener('themeChange', handleThemeChange);
    // return () => window.removeEventListener('themeChange', handleThemeChange);
    localStorage.removeItem('themeMode');
  }, []);

  const managedRoutes = useMemo(() => {
    const router = new RouterManager(access);
    return router.manager() ?? [];
  }, [access]);

  const listRoutes = useMemo(
    () =>
      createBrowserRouter([
        {
          element: <AuthLayout />,
          children: [
            {
              path: '/',
              element: <LoginForm />,
            },
            {
              path: 'recoverPassword',
              element: <RecoverPasswordForm />,
            },
            {
              path: 'resetPassword/:token',
              element: <ResetPasswordForm />,
            },
            {
              path: 'register',
              element: <RegisterForm />,
            },
          ],
        },
        {
          path: 'contato',
          element: <ComponentLeadForm />,
        },
        {
          path: 'app',
          element: <Template />,
          children: [
            {
              path: '',
              element: <OnboardingWrapper />,
              children: managedRoutes,
            },
            {
              path: 'help',
              element: <HelpPage />,
            },
          ],
        },
        {
          path: 'app/profile',
          element: <ComponentProfile />,
        },
      ]),
    [managedRoutes]
  );

  return (
    <CustomProvider theme="light">
      <RouterProvider router={listRoutes} />
      <ToastContainer />
    </CustomProvider>
  );
}

export default App;
